import { buildUserPath } from "../../storage";
import { StorageUploadFile } from "../../storage/common";
import { StorageAdapter, StorageCallback } from "../../storage/StorageAdapter";
import { ILogger } from "../../utils/logger";
import { BaseStorageService } from "../StorageService";
import { UserService } from "./UserService";

/** Takes care of all the avatars storage for users */
export class StorageUserService extends BaseStorageService {
    constructor(
        protected userId: string,
        protected userService: UserService,
        storageAdapter: StorageAdapter,
        logger?: ILogger,
    ) {
        super(storageAdapter, logger)
    }

    protected getBasePath(): string {
        return buildUserPath(this.userId);
    }

    // Customize file size limit (20MB for user media)
    protected getMaxFileSize(): number {
        return 20 * 1024 * 1024; // 20MB
    }

    // Only allow images
    protected getAllowedMimeTypes(): string[] {
        return [
            'image/jpeg',
            'image/png',
            'image/gif',
            'image/webp',
        ];
    }

    /**
     * Custom method to upload with user context
     */
    async uploadForUser(
        buffer: StorageUploadFile,
        filename: string,
        callback?: StorageCallback
    ): Promise<{ path: string; url: string; size: number }> {
        const result = await this
            .upload(buffer, filename, callback, {
                userId: this.userId,
                originalFileName: filename,
            });

        // Track in database
        await this.userService
            .update(this.userId, { avatar_url: result.url });

        return result;
    }

    /**
     * Custom method to delete all user media 
     */
    async deleteUserMedias(userId: string): Promise<void> {
        // Get all media for channel from database
        await this.deleteDirectory(buildUserPath(userId));
    }
}